function customInitialize(map) {
  this._map = map;
  const div = document.createElement('div');
  const divStyle = div.style;
  divStyle.position = 'absolute';
  divStyle.width = 'auto';
  divStyle.height = 'auto';
  divStyle.textAlign = 'center';
  divStyle.zIndex = this.zIndex;
  // 必须开启 pointer-events，否则 div 无法接收鼠标事件，事件会直接落到 canvas
  divStyle.pointerEvents = 'auto';
  div.innerHTML = this.domStr;

  // 挂载到 floatPane（最上层信息窗口层），确保 overlay 在 marker 之上，
  // 从而拦截点击、阻止穿透到下方 marker。
  // 如果 floatPane 不可用则回退到 markerPane。
  const panes = map.getPanes();
  if (panes && panes.floatPane) {
    panes.floatPane.appendChild(div);
  } else if (panes && panes.markerPane) {
    panes.markerPane.appendChild(div);
  }

  // 拦截鼠标和触摸事件，阻止冒泡到地图 canvas 触发底层 marker click
  const stopEvent = function (e) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
  };
  div.onmousedown = stopEvent;
  div.onmouseup = stopEvent;
  div.onclick = stopEvent;
  div.ontouchstart = stopEvent;
  div.ontouchend = stopEvent;

  this._div = div;
  return div;
}

function customDraw() {
  if (this._div && this._map) {
    const pixel = this._map.pointToOverlayPixel(this.position);
    const divStyle = this._div.style;
    // 使覆盖物中心点对齐经纬度坐标点
    const left = pixel.x - this._div.clientWidth / 2 + 'px';
    const top = pixel.y - 100 + this.offsetTop + 'px';
    divStyle.left = left;
    divStyle.top = top;
  }
}

function customDestroy() {
  if (this._div) {
    this._div.onmousedown = null;
    this._div.onmouseup = null;
    this._div.onclick = null;
    this._div.ontouchstart = null;
    this._div.ontouchend = null;
    this._div.parentNode && this._div.parentNode.removeChild(this._div);
    this._div = null;
  }
}

function customSetMap(map) {
  if (map) {
    map.addOverlay(this);
  } else if (this._map) {
    this._map.removeOverlay(this);
    this.destroy();
    this._map = null;
  }
}

function CustomOverlay(domStr, position, offsetTop, zIndex = 0) {
  // 动态继承 BMapGL.Overlay：百度 GL 要求自定义覆盖物必须继承 Overlay 基类，
  // 否则 map.addOverlay 不会调用 initialize / draw
  const BMapGL = window.BMapGL;
  if (BMapGL && !(CustomOverlay.prototype instanceof BMapGL.Overlay)) {
    const proto = new BMapGL.Overlay();
    proto.initialize = customInitialize;
    proto.draw = customDraw;
    proto.destroy = customDestroy;
    // 覆盖默认的 setMap，使其兼容 overlay.setMap(null) 的移除方式
    proto.setMap = customSetMap;
    CustomOverlay.prototype = proto;
  }

  this.domStr = domStr;
  this.position = position;
  this.offsetTop = offsetTop;
  this.zIndex = zIndex ?? 0;
}

// 兜底：模块加载时先挂上方法，防止 BMapGL 尚未加载
CustomOverlay.prototype.initialize = customInitialize;
CustomOverlay.prototype.draw = customDraw;
CustomOverlay.prototype.destroy = customDestroy;
CustomOverlay.prototype.setMap = customSetMap;

export default CustomOverlay;
